import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuthStore } from '@/stores/auth.store';

interface RoleGateProps {
  /** Lista de papéis permitidos. Usuário precisa ter ao menos 1. */
  papeisPermitidos: string[];
  /** Conteúdo renderizado se autorizado. */
  children: ReactNode;
  /** Fallback se não autorizado. Default: `/dashboard`. */
  redirecionarPara?: string;
}

/**
 * Guard de papel na camada de roteamento. O backend é fonte da verdade (403
 * via RolesGuard), mas escondemos visualmente para não vazar UI inacessível.
 * R1/P14: item "Usuários" no menu já é condicional; aqui adicionamos a
 * proteção de URL direta.
 */
export function RoleGate({
  papeisPermitidos,
  children,
  redirecionarPara = '/dashboard',
}: RoleGateProps) {
  const papeis = useAuthStore((s) => s.usuario?.papeis ?? []);
  const ok = papeis.some((p) => papeisPermitidos.includes(p));
  if (!ok) {
    return <Navigate to={redirecionarPara} replace />;
  }
  return <>{children}</>;
}
